import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

import { baseErrorMessages } from './baseErrorMessages';

export const reportErrorMessages: ErrorMessages = {
  ...baseErrorMessages,
  404: {
    title: 'Nie znaleziono ucznia',
    detail: 'Konto ucznia nie istnieje lub zostało usunięte',
  },
  [ErrorCodes.FORBIDDEN.REPORT.NOT_STUDENT]: {
    title: 'To nie jest konto ucznia',
    detail: 'Raport można wygenerować tylko dla konta ucznia',
  },
  [ErrorCodes.VALIDATION.INVALID_VALUE.DATE_RANGE]: {
    title: 'Nieprawidłowy zakres dat',
    detail: 'Data początkowa nie może być późniejsza niż data końcowa',
  },
};
